import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown } from '@fortawesome/free-solid-svg-icons'
import type {
  GrowthWheelVersionMeta,
  WheelVersionDisplayStatus,
} from '../../types/GrowthWheel'
import { toWheelVersionDisplayStatus } from '../../types/GrowthWheel'
import { VersionStatusBadge, formatCreatedDate } from './wheelVersionBarUtils'

export function VersionDropdown({
  current,
  currentDisplayStatus,
  sorted,
  selectedVersionId,
  open,
  setOpen,
  onSelectVersion,
}: {
  current: GrowthWheelVersionMeta
  currentDisplayStatus: WheelVersionDisplayStatus
  sorted: GrowthWheelVersionMeta[]
  selectedVersionId: number
  open: boolean
  setOpen: React.Dispatch<React.SetStateAction<boolean>>
  onSelectVersion: (versionId: number) => void
}) {
  return (
    <div>
      <p className="gw-version-bar__label">Version</p>
      <div className="gw-version-bar__dropdown-wrap">
        <button
          type="button"
          onClick={() => setOpen(prev => !prev)}
          className="gw-version-bar__dropdown-trigger"
        >
          <span className="gw-version-bar__dropdown-label">{current.label}</span>
          <VersionStatusBadge status={currentDisplayStatus} />
          <FontAwesomeIcon icon={faChevronDown} className="gw-version-bar__chevron" />
        </button>
        {open ? (
          <div className="gw-version-bar__dropdown-panel">
            {sorted.map(version => {
              const displayStatus = toWheelVersionDisplayStatus(version.status)
              return (
                <button
                  key={version.id}
                  type="button"
                  onClick={() => {
                    onSelectVersion(version.id)
                    setOpen(false)
                  }}
                  className={`gw-version-bar__dropdown-item ${
                    version.id === selectedVersionId
                      ? 'gw-version-bar__dropdown-item--selected'
                      : ''
                  }`}
                >
                  <div className="gw-version-bar__dropdown-item-head">
                    <span>{version.label}</span>
                    <VersionStatusBadge status={displayStatus} />
                  </div>
                  <div className="gw-version-bar__dropdown-item-date">
                    Created {formatCreatedDate(version.createdAt)}
                  </div>
                </button>
              )
            })}
          </div>
        ) : null}
      </div>
    </div>
  )
}
